import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import context from './recipesContext';
import { fetchDrinksFiltered, fetchFoodsFiltered } from '../services/fetchAPI';

function Provider({ children }) {
  const [searchBarIsVisible, setSearchBarIsVisible] = useState(false);
  const [filterFoods, setFilterFoods] = useState({ value: '', filter: 'name' });
  const [filterDrinks, setFilterDrinks] = useState({ value: '', filter: 'name' });
  const [foods, setFoods] = useState([]);
  const [drinks, setDrinks] = useState([]);
  const [ingredients, setIngredients] = useState([]);
  const [favorite, setFavorite] = useState(false);
  const [checked, setChecked] = useState([]);

  const getFavoriteRecipes = localStorage.getItem('favoriteRecipes');
  const favoriteRecipes = JSON.parse(getFavoriteRecipes) || [];
  const doneRecipes = JSON.parse(localStorage.getItem('doneRecipes')) || [];

  const changeFavoriteButton = (id) => {
    const favoriteRecipe = favoriteRecipes.some((recipe) => recipe.id === id);
    if (favoriteRecipe) {
      setFavorite(true);
    } else {
      setFavorite(false);
    }
  };

  const arrayIngredients = (objeto) => {
    const array = [];
    const MAX_INGREDIENTS_COUNT = 20;
    for (let i = 1; i <= MAX_INGREDIENTS_COUNT; i += 1) {
      if (objeto[`strIngredient${i}`]) {
        array.push(
          `${objeto[`strIngredient${i}`]} - ${objeto[`strMeasure${i}`]}`,
        );
      } else {
        break;
      }
    }
    setIngredients(array);
  };

  const buttonSearch = () => {
    setSearchBarIsVisible(!searchBarIsVisible);
  };

  useEffect(() => {
    fetchDrinksFiltered(filterDrinks).then((data) => setDrinks(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterDrinks]);

  useEffect(() => {
    fetchFoodsFiltered(filterFoods).then((data) => setFoods(data));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterFoods]);

  const contextValue = {
    foods,
    setFoods,
    drinks,
    setDrinks,
    searchBarIsVisible,
    buttonSearch,
    filterFoods,
    setFilterFoods,
    filterDrinks,
    setFilterDrinks,
    ingredients,
    arrayIngredients,
    setFavorite,
    changeFavoriteButton,
    favorite,
    favoriteRecipes,
    checked,
    setChecked,
    doneRecipes,
  };

  return (
    <context.Provider value={ contextValue }>
      {children}
    </context.Provider>
  );
}

Provider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Provider;
